import IconCircleTick from "app/pages/.shared/static/icons/IconCircleTick";
import React from "react";
import "./AtolButtonLabel.scss";

const AtolButtonLabel = () => {
	return (
		<div className="atol-button-label">
			<IconCircleTick width={15} height={15} />
			ATOL & ABTA protected
		</div>
	);
};

export default React.memo(AtolButtonLabel);
